import type { BridgewayApi } from '@/api/BridgewayApi';
import { logger } from '@/logger';
import { buildPartialUpdate } from '@/spaces/brand/useBusinessProfileApi';

/**
 * Writes the monthly marketing budget to the Business Profile so the user can
 * edit it later in the Brand space. Fire-and-forget: onboarding never blocks
 * on this — a failed save is logged and the wizard moves on, the same posture
 * Brand-space profile edits take.
 */
export async function saveMarketingBudget(
	api: BridgewayApi,
	userId: string,
	amount: number,
): Promise<void> {
	try {
		await api.patch(
			`/api/user/${userId}/business-profile`,
			buildPartialUpdate('my_business.marketing_budget', amount),
		);
	} catch (err) {
		logger.error('Failed to save marketing budget', err);
	}
}
